import ReactDOM from 'react-dom';
import Auth0, { Auth0Provider } from "@auth0/auth0-react"
import './index.scss';
import App from './view/App';
import { Store } from './model/store/Store';
import { Referrer } from './model/store/providers/Referrer';
import { EnabledLocalSystems, LocalSystemFilter } from './model/store/providers/LocalSystemFilter';
import { BrowserRouter } from 'react-router-dom';
import React, { useCallback, useContext } from 'react';
import {
	ritchieIdApiUrl,
	auth0Domain,
	clientId,
	redirectUri,
	scopes
} from './config';
import { Localization } from './model/store/providers/Localization';
import { AuthRedirect } from './model/store/providers/AuthRedirect';

interface AppState extends Auth0.AppState {
	referrerLabel?: string;
	referrerUrl?: string;
	enabledLocalSystems?: EnabledLocalSystems;
	language?: string;
};

ReactDOM.render(
	<React.StrictMode>
		<Store>
			<Index />
		</Store>
	</React.StrictMode>,
	document.getElementById('root')
);

function Index() {
	const dispatch = useContext(Referrer.Dispatch);
	const dispatchLocalSystemsFilter = useContext(LocalSystemFilter.Dispatch)
	const dispatchLocalization = useContext(Localization.Dispatch);
	const dispatchAuthRedirect = useContext(AuthRedirect.Dispatch);
	const onRedirectCallback = useCallback((appState: AppState) => {
		const {
			referrerLabel = '',
			referrerUrl = '',
			enabledLocalSystems = {},
			language = ''
		} = appState || {};

		dispatch({
			type: 'setReferrer',
			referrerLabel,
			referrerUrl
		});

		dispatchLocalSystemsFilter({
			type: 'setLocalSystemsFilter',
			enabledLocalSystems
		});

		dispatchLocalization({
			type: 'setLanguage',
			language
		});

		dispatchAuthRedirect({ type: 'redirectionComplete' });
		removeOAuthSpecificParams();
	}, [dispatch, dispatchLocalSystemsFilter, dispatchLocalization, dispatchAuthRedirect]);

	return(
		<Auth0Provider
			domain={auth0Domain}
			clientId={clientId}
			cacheLocation="localstorage"
			useRefreshTokens={false}
			audience={ritchieIdApiUrl}
			scope={scopes}
			redirectUri={redirectUri}
			onRedirectCallback={onRedirectCallback}
		>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Auth0Provider>
	)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

/**
 * Removes the Query String params that are specific to OAuth (i.e. 'code' and 'state')
 */
function removeOAuthSpecificParams() {
	const { protocol, host, pathname, search } = window.location;
	const newSearchStr = search.replace(/(\?)|(code=[^&]*&?)|(state=[^&]*&?)/g, '');
	let newUrl = `${protocol}//${host}${pathname}`;

	if (newSearchStr) newUrl += `?${newSearchStr}`;

	window.history.pushState({ path: newUrl }, '', newUrl);
}